import { Base_Url } from "../../../BaseURL/BaseUrl";
import { getApiWithAuthorization, postApiWithAuthorization } from "../../ApiMethods/ApiMethod";

const LeaveTypeUrl = `${Base_Url}/LeaveType`;

export const GetLeaveTypeList = async (params) => {
    const res = await postApiWithAuthorization(`${LeaveTypeUrl}/GetLeaveTypeList`, params);
    return res;
};

export const AddUpdateLeaveType = async (params) => {
    const res = await postApiWithAuthorization(`${LeaveTypeUrl}/AddUpdateLeaveType?ModuleName=${params.ModuleName}`, params);
    return res;
};
export const GetLeaveTypeModel = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${LeaveTypeUrl}/GetLeaveTypeModel?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&LeaveTypeKeyID=${KeyID}`);
    return res;
};

export const ChangeLeaveTypeStatus = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${LeaveTypeUrl}/ChangeLeaveTypeStatus?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&LeaveTypeKeyID=${KeyID}`);
    return res;
};

export const DeleteLeaveType = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${LeaveTypeUrl}/DeleteLeaveType?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&LeaveTypeKeyID=${KeyID}`);
    return res;
};

export const GetLeaveTypeLookupList = async (ModuleName, KeyID) => {
    const res = await getApiWithAuthorization(`${LeaveTypeUrl}/GetLeaveTypeLookupList?ModuleName=${ModuleName}&UserKeyID=${KeyID}`);
    return res;
};

export const GetExpenseLookupList = async () => {
    const res = await getApiWithAuthorization(`${Base_Url}/ExpenseCategory/GetExpenseCategoryLookupList`);
    return res;
};